import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { getRecommendationReason, ReasonContext } from '../agent-home.helpers';

// "Recommended for your world" (specs/ai-agent-home-redesign US-6). Each card keeps its own
// title/subtitle; the green reason line is derived from the fan's saved preferences and hidden
// when nothing matches. Badge colours still come from the parent's per-item colour rules.
@Component({
  selector: 'app-agent-recommended',
  templateUrl: './agent-recommended.component.html',
  styleUrls: ['./agent-recommended.component.scss'],
})
export class AgentRecommendedComponent implements OnChanges {
  @Input() items: any[] = [];
  @Input() subtitle = '';
  @Input() loading = false;
  @Input() hasPreferences = false;
  @Input() reasonContext: ReasonContext | null = null;
  @Input() badgeColor: (item: any) => string = () => '';
  @Input() badgeFontColor: (item: any) => string = () => '';
  @Output() itemSelected = new EventEmitter<any>();
  @Output() whyThese = new EventEmitter<void>();

  reasons = new Map<any, string>();

  ngOnChanges(): void {
    this.reasons = new Map(
      (this.items || []).map(item => [item, this.reasonContext ? getRecommendationReason(item, this.reasonContext) : ''])
    );
  }
}
